<template>
  <div class="sofia-home">
    <div
      class="home-container d-flex flex-column justify-content-around"
      :class="sofia_file_uploader_container_class"
      id="drag-drop-container"
      @dragover="drag_over"
      @dragleave="drag_leave"
      @drop="drop"
    >
      <div v-if="uploading_file">
        <div class="justify-content-center d-flex flex-column">
          <div class="col-md-4 text-center m-auto">
            <span
              class="loader-general fileUp mb-2"
              style="z-index: 100"
              id="analysis-loader"
            ></span>
          </div>
          <div
            class="row selected_file"
            v-if="is_selected_file"
            :key="selected_file.name"
          >
            <h3 class="file_name text-center w-100">
              {{ selected_file.name }}
            </h3>
          </div>
          <button
            id="cancel-button"
            type="button"
            v-if="!time_out_request && !error && !creating_file"
            class="btn btn-link p-0 mt-1"
            @click="cancel()"
          >
            {{ t("components.sofia_file_analyzer.cancel") }}
          </button>
          <span v-else class="text-primary text-center mt-1" id="new_document_label" disabled>
            {{ uploading_file_text }}
          </span>
        </div>
      </div>
      <div class="col-10 offset-1" v-else>
        <div class="p-2">
          <p class="text-center m-0">
            {{ t("sofia.sofia_uploader.analysis_text") }}
          </p>
        </div>
        <div class="container">
          <div class="row documents-btns-container">
            <div class="col-12 col-md-6">
              <label
                class="btn-file-select btn btn-primary cursor-pointer"
                for="assetsFieldHandle"
                id="input_file_selector"
              >
                <input
                  type="file"
                  id="assetsFieldHandle"
                  class="d-none"
                  @change="onChange"
                  ref="file"
                  accept=".pdf,.txt,.rtf,.doc,.docx,.odt,.html,.ott,.sxw"
                />
                <i class="fas fa-cloud-upload-alt fa-6x"></i>
                <label
                  class="text-center"
                  id="file-selector-text"
                  for="assetsFieldHandle"
                >
                  <span id="select" class="cursor-pointer">
                    {{ t(`sofia.sofia_uploader.${this.appname}.from_pc`) }}
                  </span>
                </label>
                <span
                  v-if="error"
                  class="error_format text-center"
                  id="file-error"
                >
                  {{ t("sofia.sofia_uploader.format_error") }}
                </span>
              </label>
            </div>
            <div
              class="col-12 col-md-6"
              @click="new_document()"
              id="new_document_button"
            >
              <div class="document-btn btn btn-primary cursor-pointer">
                <i class="far fa-file-alt fa-7x"></i>
                <label class="text-center">{{
                  t("sofia.sofia_uploader.new_document")
                }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex justify-content-center text-box">
            <textarea
              id="new-document-text"
              type="text"
              v-model="text"
              :placeholder="t('components.sofia.home.placeholder')"
            />
            <button
              id="new-document-text-button"
              class="btn-send btn"
              @click="new_document(text)"
            >
              <span>{{ t("components.sofia.home.analyze") }}</span>
              <i class="fas fa-chevron-right"></i>
            </button>
            <button
              id="new-document-text-button-paste"
              v-if="pasteClipboardAvailable"
              class="btn-paste btn"
              @click="pasteAndCreateNewDocument"
            >
              <span>{{ t("components.sofia.home.paste") }}</span>
              <i class="fas fa-paste"></i>
            </button>
          </div>
        </div>

        <p v-if="error_upload" class="text-center mt-3 m-0 error_format">
          {{ t("sofia.sofia_uploader.error_uploading") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "common/mixins.js";
import SofiaUploaderMixin from "common/mixins/uploader_mixin";

export default {
  name: "sofia-home-vue",
  mixins: [mixins.requests, mixins.translate, SofiaUploaderMixin],
  components: {
    "sofia-header-vue": () => import(/* webpackChunkName: "[request]" */ "components/sofia/Header"),
  },
  data() {
    return {
      text: '',
      appname: gon.current_app
    }
  },
  computed: {
    pasteClipboardAvailable(){
      if (navigator.clipboard == undefined ) return false

       return navigator.clipboard.readText != undefined
    }
  },

  methods: {
    async pasteAndCreateNewDocument(){
      this.text = await navigator.clipboard.readText()
      this.new_document(this.text)
    }
  }
};
</script>
